<template>
  <CheckoutFinalize
    v-if="checkoutStore.initialized"
    :payment-intent-id="route.query.payment_intent as string"
  />
</template>

<script setup lang="ts">
import CheckoutFinalize from '@/checkout/CheckoutFinalize.vue';
import { useCheckoutStore } from '@/stores/checkout';
import { useRoute } from 'vue-router';
import { onMounted } from 'vue';

const route = useRoute();

const checkoutStore = useCheckoutStore();

onMounted(() => {
  const shoppingCartToken = route.query['shoppingCartToken'];
  if (shoppingCartToken) {
    checkoutStore.setShoppingCartToken(shoppingCartToken);
  }

  checkoutStore.init();
});

</script>
